<template>
  <div class="container">
        
      
    <v-data-table
      :headers="headers"
      :items="items"
      :search="search"
      sort-by="calories"
      class="elevation-1">
      
      
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Συναλλασσόμενοι</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          
          <v-spacer></v-spacer>
          <v-text-field
          v-model="search"
          label="Αναζήτηση"
          prepend-inner-icon="mdi-magnify"
          variant="outlined"
          hide-details
          single-line
          clearable
        ></v-text-field>

          <v-spacer></v-spacer>

          <v-btn color="success" dark class="m-2" @click="excelPlease" v-show="showExport" v-bind:loading="getExcelButtonDisabled">
              ΕΞΑΓΩΓΗ
            </v-btn>

          <v-dialog v-model="dialog" max-width="500px" persistent>
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="primary" dark class="m-2" v-bind="attrs" v-on="on">
                ΔΗΜΙΟΥΡΓΙΑ
              </v-btn>
            </template>

            



            <v-card
              class="mx-auto"
              max-width="500">
              
              <v-card-title class="text-h6 font-weight-regular justify-space-between">
                <span>Στοιχεία συναλλασσόμενου</span>
                <v-spacer></v-spacer>
                <v-btn color="error" v-on:click="close()">X</v-btn>
              </v-card-title>
          

              
              <v-window v-model="step">
                <v-window-item :value="0">
                  <v-card-text>
                    <h3 class="text-h6 font-weight-light mb-2">Βασικά στοιχεία</h3>
                    <v-form>
                      <v-text-field 
                        v-model="editedItem.name" 
                        label="Επωνυμία"
                        v-bind:error-messages="allerrors.name">
                      </v-text-field>
                      <v-text-field 
                        v-model="editedItem.trade_name" 
                        label="Διακριτικός τίτλος"
                        v-bind:error-messages="allerrors.trade_name">
                      </v-text-field>
                      <v-text-field 
                        v-model="editedItem.tax_registration_number"
                        label="ΑΦΜ"
                        append-icon="mdi-account-search"
                        @click:append="taxRegistrationNumberSearch"
                        v-bind:error-messages="allerrors.tax_registration_number">
                      </v-text-field>

                      <v-select 
                        v-model="editedItem.tax_registration_office_id"
                        v-bind:items="taxOffices" 
                        item-text="name" 
                        item-value="id" 
                        label="ΔΟΥ"
                        v-bind:error-messages="allerrors.tax_registration_office_id">
                      </v-select>

                      <v-text-field 
                        v-model="editedItem.jobtitle"
                        label="Επάγγελμα"
                        append-icon="mdi-account-search"
                        v-bind:error-messages="allerrors.jobtitle">
                      </v-text-field>

                    </v-form>
                      <span class="text-caption grey--text text--darken-1">
                        Ο ΑΦΜ είναι υποχρεωτικός για πελάτες χονδρικής
                      </span>
                  </v-card-text>
                </v-window-item>
          
                <v-window-item :value="1">
                  <v-card-text>
                    <h3 class="text-h6 font-weight-light mb-2">Στοιχεία διεύθυνσης</h3>
                    <v-select 
                      v-model="editedItem.country_id"
                      v-bind:items="countries" 
                      label="Χώρα" 
                      item-text="name_gr" 
                      item-value="id"
                      v-bind:error-messages="allerrors.country_id">
                    </v-select>

                    <v-combobox
                      v-model="editedItem.city"
                      v-bind:items="filteredCities"
                      label="Πόλη"
                      v-bind:error-messages="allerrors.city">
                    </v-combobox>
                    
                    <v-text-field 
                      v-model="editedItem.address" 
                      label="Διεύθυνση"
                      v-bind:error-messages="allerrors.address">
                    </v-text-field>
                    
                    <v-text-field 
                      v-model="editedItem.zipcode" 
                      label="ΤΚ"
                      v-bind:error-messages="allerrors.zipcode">
                    </v-text-field>
                  </v-card-text>
                </v-window-item>
                
                <v-window-item :value="2">
                  <v-card-text>
                    <h3 class="text-h6 font-weight-light mb-2">Στοιχεία επικοινωνίας</h3>
                    <v-form>
                      <v-text-field 
                        v-model="editedItem.telephone" 
                        label="Αριθμός τηλεφώνου"
                        v-bind:error-messages="allerrors.telephone">
                      </v-text-field>
                      
                      <v-text-field 
                        v-model="editedItem.mobile" 
                        label="Αριθμός κινητού"
                        v-bind:error-messages="allerrors.mobile">
                      </v-text-field>

                      <v-text-field 
                        v-model="editedItem.fax" 
                        label="Αριθμός Φαξ"
                        v-bind:error-messages="allerrors.fax">
                      </v-text-field>

                      <v-text-field 
                        v-model="editedItem.email" 
                        label="E-Mail"
                        v-bind:error-messages="allerrors.email">
                      </v-text-field>

                      <span class="text-caption grey--text text--darken-1">
                        Το e-mail είναι υποχρεωτικό για την αποστολή τιμολογίων
                      </span>
                    </v-form>

                  </v-card-text>
                </v-window-item>
          
          
                <v-window-item :value="3">
                  <div class="pa-4">

                    <v-text-field 
                      v-model="editedItem.representative" 
                      label="Αντιπρόσωπος"
                      v-bind:error-messages="allerrors.representative">
                    </v-text-field>
                    
                    <v-text-field 
                      v-model="editedItem.distributor" 
                      label="Διανομέας"
                      v-bind:error-messages="allerrors.distributor">
                    </v-text-field>

                    <v-text-field 
                      v-model="editedItem.discount_percentage" 
                      label="Ποσοστό έκπτωσης"
                      v-bind:error-messages="allerrors.distributor">
                    </v-text-field>

                    <v-select 
                      v-model="editedItem.sales_pricelist_id"
                      v-bind:items="salesPricelists" 
                      label="Τιμοκατάλογος πωλήσεων" 
                      item-text="name" 
                      item-value="id"
                      clearable
                      v-bind:error-messages="allerrors.sales_pricelist_id">
                    </v-select>

                    <v-select 
                      v-model="editedItem.purchases_pricelist_id"
                      v-bind:items="purchasesPricelists" 
                      label="Τιμοκατάλογος αγορών" 
                      item-text="name" 
                      item-value="id"
                      clearable
                      v-bind:error-messages="allerrors.purchases_pricelist_id">
                    </v-select>

                    <v-text-field
                        v-model="editedItem.logariasmos_esodon"
                        label="Λογαριασμός εσόδων"
                        v-bind:error-messages="allerrors.code">
                    </v-text-field>

                    <v-text-field
                        v-model="editedItem.logariasmos_eksodon"
                        label="Λογαριασμός εξόδων"
                        v-bind:error-messages="allerrors.code">
                    </v-text-field>

                  </div>
                </v-window-item>

                <v-window-item :value="4" :disabled="editedIndex === -1">
                  <div class="pa-4">
                    <v-data-table :headers="headers2" :items="items2">
                      <template v-slot:top>
                        <v-toolbar flat>
                          <v-toolbar-title>Υποκαταστήματα</v-toolbar-title>
                          <v-spacer></v-spacer>
                          <v-btn color="primary" dark class="mb-2" @click="createBranch" :disabled="editedIndex === -1">ΠΡΟΣΘΗΚΗ</v-btn>
                        </v-toolbar>
                      </template>
                      <template v-slot:[`item.actions`]="{ item }">
                        <v-icon small class="mr-2" @click="editBranch(item)">mdi-pencil</v-icon>
                        <v-icon small @click="deleteBranch(item)">mdi-delete</v-icon>
                      </template>
                    </v-data-table>

                    <h3 class="text-h6 font-weight-light mb-2">Ολοκλήρωση επεργασίας</h3>
                    <div class="text-center">
                      <v-btn class="mb-4 mt-4" color="success" v-bind:loading="saveButtonDisabled" @click="save">ΑΠΟΘΗΚΕΥΣΗ</v-btn>
                    </div>
                  </div>
                </v-window-item>
                  
                
                
              </v-window>

          
              <v-divider></v-divider>
          
              <v-card-actions>
                <v-btn
                  v-bind:disabled="step <= 0"
                  text
                  v-on:click="step--"
                  color="primary">
                  ΠΙΣΩ
                </v-btn>
                <v-spacer></v-spacer>
                <v-item-group
                  v-model="step"
                  class="text-center"
                  mandatory>
                  <v-item
                          v-for="n in totalSteps"
                          :key="`btn-${n}`"
                          v-slot="{ active, toggle }">
                    <v-btn
                          :input-value="active"
                          icon
                          @click="toggle">
                      
                      <v-icon>mdi-record</v-icon>
                    </v-btn>
                  </v-item>
                </v-item-group>
                
                <v-spacer></v-spacer>
                <v-btn
                  :disabled="step >= totalSteps - 1"
                  color="primary"
                  depressed
                  @click="step++">
                  ΕΠΟΜΕΝΟ
                </v-btn>
              </v-card-actions>
            </v-card>



          </v-dialog>





          <v-dialog v-model="dialogDelete" max-width="500px">
            <v-card>
              <v-card-title class="text-h5">Διαγραφή εγγραφής "{{ editedItem.name }}";</v-card-title>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary darken-1" text @click="closeDelete">ΑΚΥΡΟ</v-btn>
                <v-btn color="error darken-1" @click="deleteItemConfirm" v-bind:loading="deleteButtonDisabled">ΕΝΤΑΞΕΙ</v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog v-model="dialogBranch" max-width="500px">
            <v-card>
              <v-card-title>
                <span class="text-h5">Στοιχεία Υποκαταστήματος</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12">
                      <v-text-field v-model="editedBranch.name" label="Όνομα"></v-text-field>
                      <v-text-field v-model="editedBranch.address" label="Διεύθυνση"></v-text-field>
                      <v-text-field v-model="editedBranch.city" label="Πόλη"></v-text-field>
                      <v-text-field v-model="editedBranch.zipcode" label="ΤΚ"></v-text-field>
                      <v-text-field v-model="editedBranch.telephone" label="Τηλέφωνο"></v-text-field>
                      <v-text-field v-model="editedBranch.email" label="Email"></v-text-field>
                      <v-text-field v-model="editedBranch.distributor" label="Διανομέας"></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="closeBranchDialog">ΑΚΥΡΟ</v-btn>
                <v-btn color="blue darken-1" text @click="saveBranch">ΑΠΟΘΗΚΕΥΣΗ</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>


        </v-toolbar>
      </template>
      
      <template v-slot:[`item.actions`]="{ item }">
        <v-icon small class="mr-2" @click="editItem(item)"> mdi-pencil </v-icon>
        <v-icon small @click="deleteItem(item)"> mdi-delete </v-icon>
      </template>
    </v-data-table>
  </div>
</template>

<script>
  export default {
    data: () => ({
      search: null,

      dialog: false,
      dialogDelete: false,
      dialogBranch: false,

      headers2: [
        { text: 'Υποκατάστημα', align: 'start', value: 'name' },
        { text: 'Διεύθυνση', align: 'start', value: 'address' },
        { text: 'Πόλη', align: 'start', value: 'city' },
        { text: 'ΤΚ', align: 'start', value: 'zipcode' },
        { text: 'Τηλέφωνο', align: 'start', value: 'telephone' },
        { text: 'Email', align: 'start', value: 'email' },
        { text: 'Διανομέας', align: 'start', value: 'distributor' },
        { text: 'Ενέργειες', value: 'actions', sortable: false },
      ],

      headers: [
        {
          text: 'Επωνυμία',
          align: 'start',
          //sortable: false,
          value: 'name',
        },
        {
          text: 'Διακ.τίτλος',
          value: 'trade_name'
        },
        {
          text: 'Αντιπρόσωπος',
          value: 'representative'
        },
        {
          text: 'Διανομέας',
          value: 'distributor'
        },
        { 
          text: 'ΑΦΜ', 
          value: 'tax_registration_number' 
        },
        // { 
        //   text: 'Επάγγελμα', 
        //   value: 'jobtitle' 
        // },
        { 
          text: 'Χώρα', 
          value: 'country_full_name_gr'
        },
        { 
          text: 'Πόλη', 
          value: 'city' 
        },
        { 
          text: 'Διεύθυνση', 
          value: 'address' 
        },
        { 
            text: 'Actions', 
            value: 'actions', 
            sortable: false,
            exportable: false,
        },
      ],

      items: [],
      customers: [],
      countries: [],
      taxOffices: [],
      salesPricelists: [],
      purchasesPricelists: [],

      allerrors: {},
      editedIndex: -1,
      editedItem: {
        name: '',
        trade_name: '',
        tax_registration_number: '',
        tax_registration_office_id: '',
        country_id: '',
        city: '',
        address: '',
        zipcode: '',
        telephone: '',
        fax: '',
        mobile: '',
        email: '',
        jobtitle: '',
        distributor: '',
        representative: '',
        sales_pricelist_id: null,
        purchases_pricelist_id: null,
        logariasmos_esodon: '',
        logariasmos_eksodon: ''
      },
      defaultItem: {
        name: '',
        trade_name: '',
        tax_registration_number: '',
        tax_registration_office_id: '',
        country_id: '',
        city: '',
        address: '',
        zipcode: '',
        telephone: '',
        fax: '',
        mobile: '',
        email: '',
        jobtitle: '',
        distributor: '',
        representative: '',
        sales_pricelist_id: null,
        purchases_pricelist_id: null,
        logariasmos_esodon: '',
        logariasmos_eksodon: ''
      },
      editedBranch: {
        id: -1,
        name: '',
        address: '',
        city: '',
        zipcode: '',
        telephone: '',
        email: '',
        distributor: ''
      },
      defaultBranch: {
        id: -1,
        name: '',
        address: '',
        city: '',
        zipcode: '',
        telephone: '',
        email: '',
        distributor: ''
      },
      saveButtonDisabled: false,
      deleteButtonDisabled: false,
      getExcelButtonDisabled: false,

      /* window stuff */
      step: 0,
      totalSteps: 5,



    }),

    computed: {
      items2() {
        return this.editedItem?.branches ?? []
      },

      formTitle () {
        return this.editedIndex === -1 ? 'Προσθήκη' : 'Επεξεργασία'
      },

      filteredCities() {
        return [ ]
      },

      showExport() {
        return this.customers?.length > 0
      }
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },
    },

    created () {
      this.initialize()
    },


    methods: {

      excelPlease() {
        if (this.customers?.length > 0 == false) {
          console.log('No items!')
          return
        }

        const transform = (line, columnDefinitions) => {
          let out = []

          columnDefinitions.forEach(columnDefinition => {

            const columnValue = line[columnDefinition.propertyName]

            if (columnDefinition.exportTransformer)
              out.push(columnDefinition.exportTransformer(columnValue))
            else
              out.push(columnValue)
          });

          return out;
        }

        const exportableColumns = this.headers.filter(x => (x.exportable ?? true) == true)
        const columnDefinitions = exportableColumns.map(x => ({ propertyName: x.value, exportTransformer: x.exportTransformer }))

        const requestBody = {
          table_headers: exportableColumns.map(x => x.text),
          table_entries: this.customers.map(line => transform(line, columnDefinitions))
        }

        this.axiosDownload('/api/test', requestBody, 'αναφορά.xls')
      },

      axiosDownload(url, requestBody, filename) {
        this.getExcelButtonDisabled = true;

        axios({
            url: url, 
            data: requestBody,
            method: 'POST',
            responseType: 'blob', // important
        }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', filename); //or any other extension
            document.body.appendChild(link);
            link.click();
            this.getExcelButtonDisabled = false
        // link.remove();
        // url.remove();

        }).catch(err => { console.log(err); this.getExcelButtonDisabled = false})
      },

      mixmatch(customer) {
        customer.country = this.countries.find(country => country.id == customer.country_id)
        customer.taxOffice = this.taxOffices.find(taxOffice => taxOffice.id == customer.tax_registration_office_id )

        customer.country_full_name_gr = customer.country.full_name_gr
        
        return customer
      },

      initialize () {
        
        this.$store.dispatch('currentUser/getCurrentUser')

        axios.all([
            axios.get('/api/accounts'),
            axios.get('/api/countries'),
            axios.get('/api/tax-offices'),
            axios.get('/api/pricelists/sales'),
            axios.get('/api/pricelists/purchases'),
        ]).then(axios.spread((customersResponse, countriesResponse, taxOfficesResponse, salesPricelistsResponse, purchasesPricelistsResponse) => {
            this.customers = customersResponse.data.sort((a, b) => a.name.localeCompare(b.name))
            this.countries = countriesResponse.data
            this.taxOffices = taxOfficesResponse.data
            this.salesPricelists = salesPricelistsResponse.data
            this.purchasesPricelists = purchasesPricelistsResponse.data
            

            
            this.customers.map(customer =>  this.mixmatch(customer))

            this.items = this.customers

        })).catch(error => { console.log(error) })
      },

      editItem (item) {
        this.editedIndex = this.items.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      deleteItem (item) {
        this.editedIndex = this.items.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },

      deleteItemConfirm () {
        this.deleteButtonDisabled = true
        axios.delete(`/api/accounts/${this.items[this.editedIndex].id}`)
        .then(response => { this.items.splice(this.editedIndex, 1); this.closeDelete(); })
        .catch(error => console.log(error))
        .finally(() => this.deleteButtonDisabled = false)
      },

      close () {
        this.allerrors = {}
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
          this.step = 0
        })
      },

      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      createBranch() {
        this.editedBranch = Object.assign({}, this.defaultBranch);
        this.dialogBranch = true;
      },

      editBranch(item) {
        this.editedBranch = Object.assign({}, item);
        this.dialogBranch = true;
      },

      deleteBranch(item) {
        if(confirm('Διαγραφή υποκαταστήματος;')) {
            axios.delete(`/api/account-branches/${item.id}`)
            .then(() => {
                // Refresh the customer list or at least the current customer's branches
                // Since items2 relies on editedItem.branches, we need to update that.
                const index = this.editedItem.branches.indexOf(item);
                if (index > -1) {
                    this.editedItem.branches.splice(index, 1);
                }
            });
        }
      },

      closeBranchDialog() {
        this.dialogBranch = false;
        this.editedBranch = Object.assign({}, this.defaultBranch);
      },

      saveBranch() {
        if (this.editedBranch.id > -1) {
            // Update
            axios.patch(`/api/account-branches/${this.editedBranch.id}`, this.editedBranch)
            .then(response => {
                const index = this.editedItem.branches.findIndex(x => x.id == this.editedBranch.id);
                if (index > -1) {
                    Object.assign(this.editedItem.branches[index], response.data);
                }
                this.closeBranchDialog();
            });
        } else {
            // Create
            this.editedBranch.account_id = this.editedItem.id;
            axios.post('/api/account-branches', this.editedBranch)
            .then(response => {
                if (!this.editedItem.branches) this.editedItem.branches = [];
                this.editedItem.branches.push(response.data);
                this.closeBranchDialog();
            });
        }
      },

      async save () {

        this.saveButtonDisabled = true
        console.log('1')
        console.log(requestBody);

        let requestBody = {
          name: this.editedItem.name,
          country_id: this.editedItem.country_id,
          city: this.editedItem.city,
          address: this.editedItem.address,
          zipcode: this.editedItem.zipcode,
          logariasmos_esodon: this.editedItem.logariasmos_esodon ?? null,
          logariasmos_eksodon: this.editedItem.logariasmos_eksodon ?? null,

          branch_distributors: this.items2.map(function (x) { return { branch_id: x.id, distributor: x.distributor } })
        }

        console.log('1.2')
        console.log(requestBody);


        let extraFields = [
            'tax_registration_number',
            'tax_registration_office_id',
            'telephone',
            'fax',
            'email',
            'mobile',
            'jobtitle',
            'trade_name',
            'distributor',
            'representative',
            'discount_percentage',
            'sales_pricelist_id',
            'purchases_pricelist_id'
        ];

        console.log('2')
        console.log(requestBody);

        console.log('wtf')

        for (let i = 0; i < extraFields.length; i++) {

          let fieldName = extraFields[i]

          let fieldValue = this.editedItem[fieldName]

          if (fieldValue == null)
          {
            console.log(`Skipping field ${fieldName} -- null`)
            continue
          }

          if (fieldValue.toString().length > 0 == false)
          {
            console.log(`Skipping field ${fieldName} -- length`)
            continue
          }


          console.log(`Adding field ${fieldName}`)
          requestBody[fieldName] = fieldValue
        }

        console.log('3')
        console.log(requestBody);

        if (this.editedIndex > -1) {
          //Object.assign(this.items[this.editedIndex], this.editedItem)
          axios.patch(`/api/accounts/${this.editedItem.id}`, requestBody)
          .then(response => { Object.assign(this.items[this.editedIndex], this.mixmatch(response.data)); this.close(); })
          .catch(error => { console.log(error) })
          .finally(() => this.saveButtonDisabled = false)
          
        } else {

          axios.post('/api/accounts', requestBody)
          .then(response => { 
            this.items.push(this.mixmatch(response.data)); 
            this.close();
          })
          .catch(error => {
            console.log(error)

            if (error.response.data)
              this.allerrors = error.response.data.errors

          })
          .finally(() => this.saveButtonDisabled = false)
        }
      },

      taxRegistrationNumberSearch() {
        if (this.editedItem.tax_registration_number.length > 7 == false)
          return

        axios.get(`/api/tax-authority/tax-registration-number-lookup/${this.editedItem.tax_registration_number}`)
        .then(response => {
          this.editedItem.name = response.data.name
          this.editedItem.address = response.data.address
          this.editedItem.zipcode =  response.data.zipcode
          this.editedItem.city = response.data.city
          this.editedItem.country_id = this.countries.find(country => country.iso_code == 'GR').id
          this.editedItem.jobtitle = response.data.jobtitle

          if (this.taxOffices.filter(taxOffice => taxOffice.id == response.tax_registration_office_id).length > 0 == false) {
            axios.get('/api/tax-offices/')
            .then(response2 => { 
              this.taxOffices = response2.data; 
              this.editedItem.tax_registration_office_id = response.data.tax_registration_office_id
            })
            .catch(error => console.log(error))
          } else {
            this.editedItem.tax_registration_office_id = response.data.tax_registration_office_id
          }

        })
        .catch(error => { console.log(error)})
      }
    },
  }
</script>

<style scoped>
.v-data-table-header th {
  white-space: nowrap;
}

.v-data-table {
  word-break: initial
}

th {
  vertical-align: top;
}
</style>